export default __webpack_public_path__ + "7TO0GSI-logo_white.svg";